import { FLAGS } from 'affiny-core/helpers/featureToggle';
import { sharedConfigLocale } from './shared-config';

export const LocalConfig = {
  credentials: {
    sentryDSN: 'https://daaa21a2bc87480e98cd8fd99be753c3@sentry.io/1405906',
    algoliaApiKey: '831506aac16971f9aa4651be9b69c814',
    algoliaAppId: 'plYG601EXJGU',
  },
  featureToggling: {
    [FLAGS.FLOATING_HOME]: true,
    [FLAGS.HOME_MESSAGE]: true,
  },
  ...sharedConfigLocale,
  // Uncomment to debug
  // googleTagManagerContainerIdForGoogleAnalytics: 'GTM-XXXXXX',
  // googleTagManagerContainerIdForOneTrust: 'GTM-PGVTX2R',
};
